/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordstrength1Inputs */

const en_passwordstrength1 = /** @type {(inputs: Passwordstrength1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password strength`)
};

const de_passwordstrength1 = /** @type {(inputs: Passwordstrength1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwortstärke`)
};

/**
* | output |
* | --- |
* | "Password strength" |
*
* @param {Passwordstrength1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrength1 = /** @type {((inputs?: Passwordstrength1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrength1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrength1(inputs)
	return de_passwordstrength1(inputs)
});
export { passwordstrength1 as "passwordStrength" }